import React from 'react';
import './BottomMenuBar.css';

const BottomMenuBar = ({ onPrev, onNext, onShowHint, isPrevDisabled, isNextDisabled }) => {
  return (
    <footer className="bottom-menu-bar">
      <button onClick={onPrev} disabled={isPrevDisabled} className="bottom-menu-bar-button-back">
        <span className="material-icons">arrow_back_ios</span>
        <span className="hidden sm:inline">Back Exercise</span>
      </button>
      <button onClick={onShowHint} className="bottom-menu-bar-button-hint">
        <span className="material-icons">lightbulb</span>
        <span>Show Hint</span>
      </button>
      <button onClick={onNext} disabled={isNextDisabled} className="bottom-menu-bar-button-next">
        <span>Next Exercise</span>
        <span className="material-icons">arrow_forward</span>
      </button>
    </footer>
  );
};

export default BottomMenuBar;
